import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import Input from './Input';

const SearchInput = ({ placeholder, ...props }) => {
  const { t } = useTranslation();

  return (
    <Input
      type='text'
      autoComplete='search'
      name='search'
      debounce
      timeout={500}
      placeholder={placeholder ?? t('search')}
      RightIcon={<Icon icon={ICONS.Search} disableCommonStyles />}
      {...props}
    />
  );
};

export default SearchInput;
